import React, { cloneElement, ReactElement } from 'react';
import { useTranslation } from '../../utils/useTranslation';
import { SmartDrawer } from '../feedback/SmartDrawer';
import { Button } from '../input/Button';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';
import { PostStatus } from './constants';

interface PostStatusDrawerProps {
    title: string;
    handleClose: VoidFunction;
    descriptionSlot?: ReactElement;
    status?: PostStatus;
    onRemove?: VoidFunction;
    isOwner: boolean;
}

export const PostStatusDrawer = (props: PostStatusDrawerProps) => {
    const { handleClose, onRemove, title, descriptionSlot, status, isOwner } = props;
    const t = useTranslation();

    return (
        <SmartDrawer
            onClose={handleClose}
            titleContent={
                <Typography variant="title3" weight="bold">
                    {title}
                </Typography>
            }
            mainContent={(onClose) => (
                <>
                    {descriptionSlot ? cloneElement(descriptionSlot) : null}
                    <Flex width="100%" spacing={1} pt={2}>
                        {status === PostStatus.MODERATION && (
                            <Button size="l" color="primary" onClick={onClose} width="100%">
                                {t('Понятно')}
                            </Button>
                        )}
                        {status === PostStatus.DECLINED && isOwner ? (
                            <Button size="l" onClick={onRemove} color="secondary" width="100%">
                                {t('Удалить пост')}
                            </Button>
                        ) : null}
                        {status === PostStatus.DECLINED && (
                            <Button size="l" onClick={onClose} color="primary" width="100%">
                                {t('Закрыть')}
                            </Button>
                        )}
                    </Flex>
                </>
            )}
        />
    );
};
